import React from "react";
import Bioblinds from "./Bioblinds";
import Layout from "./../Layout/Layout";

const Index = () => {
  return (
    <Layout>
      <Bioblinds />
    </Layout>
  );
};

export default Index;
